<template>
	<div class=" m-t-0 w-1200">
    <el-button type="primary" size="small" class="fr m-l-50 m-b-10" @click="dialogFormVisible = true">添加配置</el-button><span style="font-weight:600;color:#00f;" class="m-l-30">配置描述【配置名称】配置内容</span>
		<el-form ref="form" :model="form" :rules="rules" label-width="400px" class="m-t-0 padding-page">
      <div class="form-pane">
      <el-form-item v-for="item in form.list" :label="item.remark+' 【'+item.name+'】'" prop="list">
        <el-input v-if="item.type==1" v-model.trim="item.value" :value="item.value" class="m-l-10 h-40 w-400"></el-input>
        <el-radio-group v-else v-model.trim="item.value" class="m-l-10 h-40 w-400">
          <el-radio label="1">开启</el-radio>
          <el-radio label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      </div>
      <el-form-item>
        <el-button type="primary" @click="add()" class="m-l-10 w-200" :loading="isLoading" size="small">保存</el-button>
      </el-form-item>
    </el-form>


    <el-dialog title="上传图片" :visible.sync="picFormVisible" size="tiny">
      <el-upload
      class="m-b-20"
      :action="uploadUrl"
      type="drag"
      :show-file-list="false"
      :thumbnail-mode="true"
      :on-preview="viewPic"
      :on-remove="handleRemove"
      :on-success="uploadSuccess"
      :on-error="uploadFail"
      :default-file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-dragger__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">正方形图片;只能上传jpg/png文件</div>
      </el-upload>
      <img style="width:100px;height: 100px" :src="pic">
      <p>图片地址：<b id="cpLink">{{pic}}</b>
      </p>
    </el-dialog>


    <el-dialog title="添加配置" :visible.sync="dialogFormVisible" size="tiny">
      <el-form ref="form" :model="formconfig" label-width="30%" :rules="rules">
        <el-form-item label="配置名称" prop="name" :label-width="formLabelWidth">
          <el-input v-model.trim="formconfig.name" placeholder="例如：SET_NAME" style="width:80%;"></el-input>
        </el-form-item>
        <el-form-item label="配置描述" prop="remark" :label-width="formLabelWidth">
          <el-input v-model.trim="formconfig.remark" placeholder="例如：前端展示——平台名称" style="width:80%;"></el-input>
        </el-form-item>
        <el-form-item label="配置内容" prop="value" :label-width="formLabelWidth">
          <el-input v-model.trim="formconfig.value" placeholder="例如：小程序，单选按钮填0或1" style="width:80%;"></el-input>
        </el-form-item>
        <el-form-item label="配置类型" prop="type">
          <el-select  v-model="formconfig.type" placeholder="选择配置的展示类型" style="width:80%">
            <el-option label="输入框" :value="1"></el-option>
            <el-option label="单选按钮" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="save('form')" size="small">确 定</el-button>
      </div>
    </el-dialog>
	</div>
</template>
<script>
  import http from '../../../../assets/js/http'

  export default {
    data() {
      return {
        isLoading: false,
        dialogFormVisible: false,
        picFormVisible: false,
        fileList: [],
        uploadUrl: '',
        pic: '',
        form: {
          list: []
        },
        formconfig: {
          name: '',
          remark: '',
          value: '',
          type: ''
        },
        rules: {
          SET_WECHAT_NAME: [
            { required: true, message: '请输入微信公众号名称' }
          ]
        }
      }
    },
    methods: {
      //  保存配置
      add() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            this.apiPost('admin/serviceConfig/save', this.form).then((res) => {
              this.handelResponse(res, (data) => {
                _g.toastMsg('success', '保存成功')
                this.isLoading = !this.isLoading
                this.getAllUsers()
              }, () => {
                this.isLoading = !this.isLoading
              })
            })
          }
        })
      },
      //  添加配置
      save(formconfig) {
        this.$refs[formconfig].validate((pass) => {
          if (pass) {
            // this.isLoading = !this.isLoading
            this.apiPost('admin/serviceConfig/addconfig', this.formconfig).then((res) => {
              this.handelResponse(res, (data) => {
                _g.toastMsg('success', '添加成功')
                this.dialogFormVisible = false
                this.getAllUsers()
              }, () => {
              })
            })
          }
        })
      },
      getAllUsers() {
        this.loading = true
        this.apiPost('admin/serviceConfig/index').then((res) => {
          this.handelResponse(res, (data) => {
            this.form.list = data
          })
        })
      },
      uploadSuccess(res, file, fileList) {
        this.pic = res.data
        let data = {
          name: '图片',
          url: res.data
        }
        this.fileList = data
      },
      uploadFail(err, res, file) {
        console.log('err = ', _g.j2s(err))
        console.log('res = ', _g.j2s(res))
      },
      handleRemove(file, fileList) {
        console.log('file = ', file)
        console.log('fileList = ', fileList)
      },
      viewPic() {
        this.propsImg = this.fileList[0].url
        this.$refs.preview.open()
      },
    },
    created() {
      this.uploadUrl = window.HOST + 'qiniu'
      this.getAllUsers()
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// add.vue?9e100c2c